import { IFlexPanelAnimationEndEvent } from '@bimser/components';
import { createMutableAction, createSyncAction } from '@bimser/core';
import {
	IWebInterfaceAction,
	WebInterfaceAction,
	WebInterfaceActionFactoryFromJS
} from '../../common/entities';
import {
	ANIMATION_END_PANEL,
	CHANGE_FOR_MOBILE_STATE,
	CHANGE_FROM_REDIRECT_STATE,
	HIDE_LEFT_AND_TOP_MENU_ACTION,
	INITIALIZE_LEFT_MENU_FOR_MOBILE_TRANSACTION,
	OPEN_MOBILE_FORM_TRANSACTION,
	OPEN_REDIRECT_FORM_TRANSACTION,
	REDIRECT_FOR_MOBILE,
	CHANGE_FLEX_PANEL_TITLE_ACTION,
	CLOSE_UNPINNED_FLEX_PANELS_TRANSACTION,
	SET_VIEW_HIDE_INFO_ACTION,
	TOGGLE_LEFT_MENU_PIN
} from './actionTypes';
import addFlexPanelAction from './addFlexPanelAction';
import clickBreadCrumbItemAction from './clickBreadCrumbItemAction';
import clickFlexPanelAction from './clickFlexPanelAction';
import clickMaximizeFlexPanelAction from './clickMaximizeFlexPanelAction';
import closeFlexPanelAction from './closeFlexPanelAction';
import closeFlexPanelByIdAction from './closeFlexPanelByIdAction';
import closeFlexPanelByIdTransactionAction from './closeFlexPanelByIdTransactionAction';
import closeFlexPanelTransactionAction from './closeFlexPanelTransactionAction';
import resizeFlexPanelAction from './resizeFlexPanelAction';
import setActiveFlexPanelAction from './setActiveFlexPanelAction';

export function animationEndAction(args: IFlexPanelAnimationEndEvent) {
	const action = createMutableAction(ANIMATION_END_PANEL, args);
	return action;
}

export function openMobileFormTransaction() {
	const action = createMutableAction(OPEN_MOBILE_FORM_TRANSACTION, null);
	return action;
}

export function openRedirectFormTransaction() {
	const action = createMutableAction(OPEN_REDIRECT_FORM_TRANSACTION, null);
	return action;
}

export function initalizeLeftMenuForMobileTransaction(data: IWebInterfaceAction) {
	const payload = WebInterfaceActionFactoryFromJS(data);
	const action = createMutableAction(INITIALIZE_LEFT_MENU_FOR_MOBILE_TRANSACTION, payload);
	return action;
}

export function changeForMobileStateAction(data: IWebInterfaceAction) {
	const payload: WebInterfaceAction = WebInterfaceActionFactoryFromJS(data);
	const action = createSyncAction(CHANGE_FOR_MOBILE_STATE, payload);

	return action;
}

export function changeRedirectStateAction(data: IWebInterfaceAction) {
	const payload: WebInterfaceAction = WebInterfaceActionFactoryFromJS(data);
	const action = createSyncAction(CHANGE_FROM_REDIRECT_STATE, payload);

	return action;
}

export function redirectForMobileStateAction(data: IWebInterfaceAction) {
	const payload: WebInterfaceAction = WebInterfaceActionFactoryFromJS(data);
	const action = createSyncAction(REDIRECT_FOR_MOBILE, payload);

	return action;
}

export function toggleLeftMenuPinAction(data: IWebInterfaceAction<boolean>) {
	const payload: WebInterfaceAction = WebInterfaceActionFactoryFromJS(data);
	const action = createSyncAction(TOGGLE_LEFT_MENU_PIN, payload);

	return action;
}

export function hideLeftAndTopMenuAction(data: IWebInterfaceAction) {
	const payload: WebInterfaceAction = WebInterfaceActionFactoryFromJS(data);
	const action = createSyncAction(HIDE_LEFT_AND_TOP_MENU_ACTION, payload);

	return action;
}

export function setViewHideInfoAction(data: IWebInterfaceAction) {
	const payload: WebInterfaceAction = WebInterfaceActionFactoryFromJS(data);
	const action = createSyncAction(SET_VIEW_HIDE_INFO_ACTION, payload);

	return action;
}

export function changeFlexPanelTitleAction(data: IWebInterfaceAction) {
	const payload: WebInterfaceAction = WebInterfaceActionFactoryFromJS(data);
	const action = createSyncAction(CHANGE_FLEX_PANEL_TITLE_ACTION, payload);
	return action;
}

export function closeUnpinnedFlexPanelsTransaction(data: IWebInterfaceAction) {
	const payload: WebInterfaceAction = WebInterfaceActionFactoryFromJS(data);
	const action = createSyncAction(CLOSE_UNPINNED_FLEX_PANELS_TRANSACTION, payload);

	return action;
}

export {
	addFlexPanelAction,
	resizeFlexPanelAction,
	closeFlexPanelAction,
	closeFlexPanelByIdTransactionAction,
	clickFlexPanelAction,
	closeFlexPanelTransactionAction,
	setActiveFlexPanelAction,
	clickBreadCrumbItemAction,
	clickMaximizeFlexPanelAction,
	closeFlexPanelByIdAction
};
